export interface MailUrlParams {
  from?: string;
  subject: string;
  body: string;
}

export function createMailUrl(mailToUrlParams: MailUrlParams): string {
  const { from, subject, body } = mailToUrlParams;

  return `mailto:?from=${from}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
